import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { Container } from 'reactstrap'

const Metrics = () => (
  <div className='animated fadeIn'>
    <Container className='py-5 company-management credentials-management' fluid>
      <h2>Metrics</h2>
      <p></p>
    </Container>
  </div>
)

export default connect()(withRouter(Metrics))
